import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=68982784"
import script from "./file-item.vue?vue&type=script&lang=js"
export * from "./file-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68982784')) {
      api.createRecord('68982784', component.options)
    } else {
      api.reload('68982784', component.options)
    }
    module.hot.accept("./file-item.vue?vue&type=template&id=68982784", function () {
      api.rerender('68982784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/audio/file-item.vue"
export default component.exports